/**
 * Pure functions for appointment calculations
 * These functions are framework-agnostic and easily testable
 */

/**
 * Calculates the expected value for an appointment
 * @param {Object} appointment - The appointment object
 * @returns {number} Expected value (sum of service prices)
 */
export function getExpected(appointment) {
  const total = appointment.services.reduce((a, s) => a + (Number(s.price) || 0), 0);
  return total;
}

/**
 * Calculates the paid amount for an appointment
 * @param {Object} appointment - The appointment object
 * @returns {number} Paid amount
 */
export function getPaid(appointment) {
  if (!isPaid(appointment)) return 0;
  return (Number(appointment.paid) || 0);
}

/**
 * Checks if an appointment has been paid
 * @param {Object} appointment - The appointment object
 * @returns {boolean} True if appointment is paid, false otherwise
 */
export function isPaid(appointment) {
  return appointment.paid !== '' && appointment.paid != null && appointment.paid !== undefined;
}
